<template>
  <NewHome  />
  
  
</template>

<script>
import axios from 'axios'
import {mapState, mapMutations, mapActions} from 'vuex'
import OldHome from '../components/OldHome.vue'
import NewHome from '../components/NewHome.vue'
import NewMobile from '../components/NewMobile.vue'
export default {
  components: { NewHome, OldHome, NewMobile },
  data() {
    return {
      plan: 'basic',
      animation: false,
      phoneCode: '+31',
  
      spanSPone: false,
      spanSPtwo: false,
      spanSPthree: false,
      checkSPone:false,
      checkSPtwo: false,
      checkSPthree:false,

      totalES: 0,
      spanES: false,
      totalESPrice: 0,

      spanDriverHelp:false,
      checkDriverHelp:false,

      spanPakMaterial:false,
      checkPakMaterial:false,

      spanVerpakHulp:false,
      checkVerpakHulp:false,

      spanDemontage:false,
      checkDemontage:false,

      spanVerhuislift:false,
      checkVerhuislift:false,

      spanTussenStop:false,
      checkTussenStop:false,

      spanFilter:false,

      selectedCommitment: '12',
      selectedSize: '',

      prefMoment: 0,
      pickupDate: '',

      klantBox: false,
      klantType: 'b2c',

      companyName: '',

      address: '',
      zip: '',
      fullName: '',
      lname: '',
      lnameError: '',
      email: '',
      phone: '',
      city: '',

      link: '',
      finError: '',
      travel: '',
      refreshedOnce: false,

      travelCost: 0,
      travelTotal: 0,
      agreeOne: false,
      agreeTwo: false,
      agreeThree: false,
    }
  },//END data()
  computed: {
    ...mapState(['categoryData','commitments','categoriesAll','offers','submitData','currentOffer','controlLink','ip','detailsEntered','currentSizeData','travelCosts'])
  },
  methods: {
    ...mapMutations(['changeCheckoutSubmit','changeCheckoutData','editSize','changeSubmitData','editCategory','changeLink','changeDetailsEntered','changeCurrentSizeData']),
    calculateDiscountPrice(price,commitment){
      if (commitment < 3) 
        return price;
      else if (commitment < 6)
        return Math.round(price * 0.90)
      else if (commitment < 12)
        return Math.round(price * 0.75)
      else if (commitment >= 12)
        return Math.round(price * 0.60)   

    },
    calculateDiscount(commitment){
      let price = this.currentOffer.price
    if (commitment < 3) 
        return price;
      else if (commitment < 6)
        return Math.round(price * 0.90)
      else if (commitment < 12)
        return Math.round(price * 0.75)
      else if (commitment >= 12)
        return Math.round(price * 0.60)     
    },
    changeKlant(){
     if(this.klantBox)
      this.klantType='b2b'
     else{
      this.klantType='b2c'
      this.companyName=''
     } 
    },
    chooseBasic(){
      this.checkSPone=true
      this.checkSPtwo=false
      this.changeSubmitData({item:'plan',new:'Doe het zelf - basic service'})
      this.changeSubmitData({item:'planPrice',new:0})
    },
    choosePremium(){
      this.checkSPone=false
      this.checkSPtwo=true
      this.changeSubmitData({item:'plan',new:'Do it for you - permium service'})
      this.changeSubmitData({item:'planPrice',new:this.currentOffer.premium})
    },
    selectCommitment(period){
      this.selectedCommitment = period
      this.changeSubmitData({item:'commitment',new:this.selectedCommitment})
      this.changeTravelCosts()

    },
    async selectSize(size){
     this.selectedSize=size
     this.editSize(size)
     this.changeSubmitData({item:'storage_size',new:this.selectedSize})
     if (this.checkSPtwo)
      this.choosePremium()
     else
      this.chooseBasic()

      await axios.get(`https://api-production.inboxstorage.eu/api/v1/control/size/getpost/${size}`).then((response)=>{     
          let data = response.data[0]  
          this.changeCurrentSizeData({item:'size',new:size})
          this.changeCurrentSizeData({item:'lineOne',new:data.lineOne})
          this.changeCurrentSizeData({item:'lineTwo',new:data.lineTwo})
          this.changeCurrentSizeData({item:'lineThree',new:data.lineThree})
          this.changeCurrentSizeData({item:'lineFour',new:data.lineFour})
          this.changeCurrentSizeData({item:'paragraphOne',new:data.body})
          this.changeCurrentSizeData({item:'paragraphTwo',new:data.bodyMin})                   
        }).catch(error => {
          
          console.log(error)
        });
       
    },
    changeTravelCosts(){
      console.log(this.travelCost)
      if(this.selectedCommitment == 1)
       this.travelTotal = this.travelCosts[this.travelCost].one
      if(this.selectedCommitment == 3)
       this.travelTotal = this.travelCosts[this.travelCost].three
      if(this.selectedCommitment == 6)
       this.travelTotal = this.travelCosts[this.travelCost].six
      if(this.selectedCommitment == 12)
       this.travelTotal = this.travelCosts[this.travelCost].twelve   

       

    },
    selectCategory(cat){
     this.editCategory(cat.i)
     this.selectSize(cat.start) 
     this.spanFilter = false
    },

    setDriverHelp(){
     this.checkDriverHelp=!this.checkDriverHelp
     if(this.checkDriverHelp){
      this.totalES++
      this.totalESPrice += 50
     }
     else{
      this.totalES--
      this.totalESPrice -=50
     }
     this.changeSubmitData({item:'totalES',new:this.totalES})
     this.changeSubmitData({item:'totalESPrice',new:this.totalESPrice})
    },
    setPakMaterial(){
      this.checkPakMaterial=!this.checkPakMaterial
     if(this.checkPakMaterial){
      this.totalES++
     }
     else{
      this.totalES--
     }
     this.changeSubmitData({item:'totalES',new:this.totalES})
    },
    setVerpakHulp(){
      this.checkVerpakHulp=!this.checkVerpakHulp
     if(this.checkVerpakHulp){
      this.totalES++
      this.totalESPrice += 160
     }
     else{
      this.totalES--
      this.totalESPrice -=160
     }
     this.changeSubmitData({item:'totalES',new:this.totalES})
     this.changeSubmitData({item:'totalESPrice',new:this.totalESPrice})

    },
    setDemontage(){
       this.checkDemontage=!this.checkDemontage
     if(this.checkDemontage){
      this.totalES++
      this.totalESPrice += 130
     }
     else{
      this.totalES--
      this.totalESPrice -=130
     }
     this.changeSubmitData({item:'totalES',new:this.totalES})
     this.changeSubmitData({item:'totalESPrice',new:this.totalESPrice})

    },
    setVerhuislift(){
        this.checkVerhuislift=!this.checkVerhuislift
     if(this.checkVerhuislift){
      this.totalES++
      this.totalESPrice += 180
     }
     else{
      this.totalES--
      this.totalESPrice -=180
     }
     this.changeSubmitData({item:'totalES',new:this.totalES})
     this.changeSubmitData({item:'totalESPrice',new:this.totalESPrice})

    },
    setTussenStop(){
         this.checkTussenStop=!this.checkTussenStop
     if(this.checkTussenStop){
      this.totalES++
      this.totalESPrice += 50
     }
     else{
      this.totalES--
      this.totalESPrice -=50
     }
     this.changeSubmitData({item:'totalES',new:this.totalES})
     this.changeSubmitData({item:'totalESPrice',new:this.totalESPrice})
    },
    getDayName(dateStr, locale){
      var date = new Date(dateStr);
      return date.toLocaleDateString(locale, { weekday: 'long' });        
    },
    getMonthName(dateStr, locale){
      var date = new Date(dateStr);
      return date.toLocaleDateString(locale, { month: 'long' });        
    },
    getDay(dateStr){
      var date = new Date(dateStr);
      return date.getDate();        
    },
    getPrefTime(moment){
      if(moment==0)
        return "08:00 - 19:00";
      if(moment==1)
        return "08:00 - 12:00";
      if(moment==2)
        return "12:00 - 16:00";
      if(moment==3)
        return "08:00 - 10:00";
      if(moment==4)
        return "Weekend";
    },
    sevenDays(){
      const date = new Date();
      date.setDate(date.getDate() + 7);
      var formatted_date = date.toJSON().slice(0,10);
      return formatted_date
    },
    setPrefMoment(moment){
      if(moment==0){
        this.changeSubmitData({item:'prefMoment',new:'Dagplanning'})
        this.changeSubmitData({item:'prefMomentPrice',new:0})
      }  
      if(moment==1){
        this.changeSubmitData({item:'prefMoment',new:'Ochtendvak'})
        this.changeSubmitData({item:'prefMomentPrice',new:20})
      }  
      if(moment==2){
        this.changeSubmitData({item:'prefMoment',new:'Middagvak'})
        this.changeSubmitData({item:'prefMomentPrice',new:20})
      }  
      if(moment==3){
        this.changeSubmitData({item:'prefMoment',new:'DagStart'})
        this.changeSubmitData({item:'prefMomentPrice',new:35})
      }  
      if(moment==4){
        this.changeSubmitData({item:'prefMoment',new:'Weekend'})
        this.changeSubmitData({item:'prefMomentPrice',new:50})
      }            
    },


    async submit(){
      this.finError = ""
      if(!this.phone){
        this.finError = "Phone number is required"
        return;
      }
      if(!this.address){
        this.finError = "Address is required"
        return;
      }
      if(!this.lname){
        this.finError = "Last name is required"
        return;
      }
      
      if (this.klantType == 'b2b' && !this.companyName){
        this.finError = "Company name required for Business client type"
        return;
      }
      this.changeSubmitData({item:'phone_number',new:this.phone})
       this.changeSubmitData({item:'oldPhone',new:this.phone})
      this.animation=true

        
       

        //HS STUFF
        let hubName = this.fullName
        let hubLname = this.lname
        let hubMail = this.email
        let hubPhone = this.phone
        let hubZip = this.zip
        let hubCity = this.city
        let hubCommitment = this.submitData.commitment
        let hubSize = this.submitData.storage_size
        let hubWhen = this.submitData.wanneer_opslagruimte_nodig
        let hubAddress = this.address
        let hubServiceType = this.submitData.plan
        let hubserviceplanprice = this.submitData.planPrice
        
        let hubDatum = this.pickupDate
        let hubMoment = this.prefMoment
        let hubCtype = this.klantType
        let hubBedrif = this.companyName

        let hubPrice = this.calculateDiscount(hubCommitment)
        let hubLink = this.link
        
        
        let hubQuotePriceOne = this.calculateDiscount(1)
        let hubQuotePriceTwo = this.calculateDiscount(3)
        let hubQuotePriceThree = this.calculateDiscount(6)
        let hubQuotePriceFour = this.calculateDiscount(12)
        let hubSquare_meters = this.currentOffer.sizeSquare *1
        let hubBasic = this.travel
        let hubPremium = (this.currentOffer.premium *1 + (this.travel/1.4*1.9)).toFixed(2)
        let hubspotFields = [
            
            {
                'name' : 'firstname',
                'value' : hubName,
            },
            {
                'name' : 'lastname',
                'value' : hubLname,
            },
            {
                'name' : 'email',
                'value' : hubMail,
            },
            {
                'name' : 'zip',
                'value' : hubZip,
            },
            
            {
                'name' : 'aantal_kuub',
                'value' : hubSize,
            },
            {
                'name' : 'when_storage_required02',
                'value' : hubWhen,
            },
            {
                'name' : 'city',
                'value' : hubCity,
            },
            {
                'name' : 'address',
                'value' : hubAddress,
            },
            {
                'name' : 'serviceType',
                'value' : hubServiceType,
            },
            {
                'name' : 'serviceplanprice',
                'value' : hubserviceplanprice,
            },

            {
                'name' : 'travelCosts',
                'value' : this.travelTotal,
            },            
            
            {
                'name' : 'phone',
                'value' : hubPhone,
            },
            {
                'name' : 'commitment',
                'value' : hubCommitment,
            },          
            {
                'name' : 'pref_date',
                'value' : hubDatum,
            },
            {
                'name' : 'voorkeursmoment',
                'value' : hubMoment,
            },
            {
                'name' : 'klanttype',
                'value' : hubCtype,
            },
            {
                'name' : 'company',
                'value' : hubBedrif,
            },
            
        ];
        let data = {}
        data['context']={
          'pageUri': 'https://inboxstorage.eu/commitment',
          'pageName': 'Commitment',
          
        }
        data['fields']=hubspotFields
        if(!this.disableHubspot){
          axios.post('https://api.hsforms.com/submissions/v3/integration/submit/1979474/2b4d8223-0fc8-4431-9495-29d330ab1cf1',data)
          .then((response)=>{     
            let res = response.data    
            //this.$router.push({path: '/thankyou'})
            this.animation = false
            this.changeDetailsEntered(2)
            
            
            
          }).catch(error => {
            console.log(error)
          });
        }
        //END HS STUFF

    },//END submit()
    refreshData(){
      if(this.refreshedOnce)
       return;
       this.refreshedOnce=true
      this.zip = this.submitData.zip
    this.city = this.submitData.city
    this.fullName = this.submitData.name
    this.email = this.submitData.email_address
    this.phone = this.submitData.oldPhone

    },
    getCommitmentTitle(commitment){
      if(commitment==1)
        return "1+ maand";
      if(commitment==3)
        return "3+ maanden";
      if(commitment==6)
        return "6+ maanden";
      if(commitment==12)
        return "12+ maanden";
    },
    getPlan(){
      return this.submitData.plan
    },
    getPlanPrice(){
      return this.submitData.planPrice
    },
    getTotalES(){
      return this.submitData.totalES
    },
    getESPrice(){
      return this.submitData.totalESPrice
    },
    getPrefMoment(){
     return this.submitData.prefMoment
    },
    getPrefMomentPrice(){
      return this.submitData.prefMomentPrice
    },
    getPrefDate(){
      return this.submitData.prefDate
    },

  },//END methods
   
  created(){
   
    
    this.pickupDate = this.sevenDays()
    this.changeSubmitData({item:'prefDate',new:this.pickupDate})
    this.prefMoment = 0
    this.selectedSize = this.submitData.storage_size
    this.selectSize(this.selectedSize)
    this.zip = this.submitData.zip
    this.city = this.submitData.city
    this.fullName = this.submitData.name
    this.email = this.submitData.email_address
    this.phone = this.submitData.oldPhone
    

  } 

}
</script>

<style scoped>
.an {
  width: 100px;
  height: 100px;
  animation-name: example;
  position: relative;
  animation-duration: 4s;
  animation-iteration-count: infinite
}
@keyframes example {
  0%   {left:0px; top:0px;}
  
  100%  {left:800px; top:0px;}
}

</style>